"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteTemplateCategory_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NoteTemplate_1 = require("./NoteTemplate");
var NoteTemplateCategory_Factory = /** @class */ (function () {
    function NoteTemplateCategory_Factory() {
    }
    NoteTemplateCategory_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            NoteTemplates: model.NoteTemplates && model.NoteTemplates.map(function (i) { return NoteTemplate_1.NoteTemplate_Factory.CreateIncoming(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    NoteTemplateCategory_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            NoteTemplates: model.NoteTemplates && model.NoteTemplates.map(function (i) { return NoteTemplate_1.NoteTemplate_Factory.CreateOutgoing(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return NoteTemplateCategory_Factory;
}());
exports.NoteTemplateCategory_Factory = NoteTemplateCategory_Factory;
